export default __webpack_public_path__ + "static/media/gtd2.9c3c6712.jpg";